import { render, staticRenderFns } from "./GlobalChapterSettings.vue?vue&type=template&id=e46624fe&scoped=true&"
import script from "./GlobalChapterSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalChapterSettings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalChapterSettings.vue?vue&type=style&index=0&id=e46624fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46624fe",
  null
  
)

export default component.exports